import React from 'react';
import type {
  Language,
  LanguageCode,
  Country,
} from '@shopify/hydrogen/storefront-api-types';
import {fetchSync, useLocalization, useNavigate} from '@shopify/hydrogen';
import clsx from 'clsx';
// @ts-expect-error incompatibility with node16 resolution
import {Listbox} from '@headlessui/react';

//components
import SpinnerIcon from '../icons/Spinner';
import {ChevronDownIcon} from '../icons/ChevronDown';
import RadioIcon from '../icons/Radio';

interface Props {}

const LanguageSelect: React.FC<Props> = ({}) => {
  const [listboxOpen, setListboxOpen] = React.useState(false);

  const {
    language: {isoCode},
    country: {isoCode: countryISOCode},
    locale,
  } = useLocalization();

  const currentLanguage = React.useMemo<{
    name: string;
    isoCode: LanguageCode;
  }>(() => {
    // const regionNames = new Intl.DisplayNames(
    //   [locale === 'ZH-TW' ? 'zh-Hant' : 'en'],
    //   {
    //     type: 'region',
    //   },
    // );
    return {
      //   name: regionNames.of(countryISOCode)!,
      name: locale === 'ZH-TW' ? '中文' : 'English',
      isoCode: isoCode as LanguageCode,
    };
  }, [isoCode]);

  const setLanguage = React.useCallback<(language: Language) => void>(
    ({isoCode: newIsoCode}) => {
      const currentPath = window.location.pathname;
      let redirectPath;

      if (newIsoCode !== 'ZH_TW') {
        if (currentLanguage.isoCode === 'ZH_TW') {
          redirectPath = `/${newIsoCode.toLowerCase()}${currentPath}`;
        } else {
          redirectPath = `/${newIsoCode.toLowerCase()}${currentPath.substring(
            currentPath.indexOf('/', 1),
          )}`;
        }
      } else {
        redirectPath = `${currentPath.substring(currentPath.indexOf('/', 1))}`;
      }
      window.location.href = redirectPath;
    },
    [],
  );

  if (!currentLanguage) {
    return null;
  }
  return (
    <Listbox onChange={setLanguage} value={currentLanguage}>
      {({open}: {open: boolean}) => {
        setTimeout(() => setListboxOpen(open));
        return (
          <div className="relative inline-flex">
            <Listbox.Button
              className={clsx(
                'flex h-[2.4rem] items-center rounded-sm bg-hk-orange px-3 py-2 text-sm font-bold duration-150 md:bg-darkGray md:bg-opacity-0',
                'hover:bg-opacity-10',
              )}
            >
              <span className="mr-2">{currentLanguage.name}</span>
              <ChevronDownIcon className={clsx(open && 'rotate-180')} />
            </Listbox.Button>

            <Listbox.Options
              className={clsx(
                'absolute top-full z-10 mt-3 min-w-[150px] overflow-hidden rounded shadow',
                'left-0 md:left-1/2 md:-translate-x-1/2',
              )}
            >
              <div className="max-h-64 overflow-y-auto bg-white">
                {listboxOpen && (
                  <Languages
                    selectedLanguage={currentLanguage}
                    countryISOCode={countryISOCode}
                    getClassName={(active: boolean) => {
                      return clsx([
                        'p-3 flex justify-between items-center text-left font-bold text-sm cursor-pointer whitespace-nowrap',
                        active ? 'bg-darkGray bg-opacity-5' : null,
                      ]);
                    }}
                  />
                )}
                {/* {listboxOpen && (
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center overflow-hidden">
                        <SpinnerIcon />
                      </div>
                    }
                  >
                    <Languages
                      selectedLanguage={currentLanguage}
                      countryISOCode={countryISOCode}
                      getClassName={(active: boolean) => {
                        return clsx([
                          'p-3 flex justify-between items-center text-left font-bold text-sm cursor-pointer whitespace-nowrap',
                          active ? 'bg-darkGray bg-opacity-5' : null,
                        ]);
                      }}
                    />
                  </React.Suspense>
                )} */}
              </div>
            </Listbox.Options>
          </div>
        );
      }}
    </Listbox>
  );
};

export function Languages({
  getClassName,
  selectedLanguage,
  countryISOCode,
}: {
  getClassName: (active: boolean) => string;
  selectedLanguage: Pick<Language, 'isoCode' | 'name'>;
  countryISOCode: string;
}) {
  // const markets: Country[] = fetchSync('/api/languages', {}).json();

  // const languagesAvailable = markets.find(
  //   (l) => l.isoCode === countryISOCode,
  // )?.availableLanguages;

  console.log(selectedLanguage);
  return (
    <>
      <Listbox.Option key={`zh-tw-1`} value={{isoCode: 'ZH_TW', name: '中文'}}>
        {({active}: {active: boolean}) => (
          <div className={getClassName(active)}>
            <span className="mr-8 font-normal">中文</span>
            <div className="text-hk-orange">
              <RadioIcon
                checked={selectedLanguage?.isoCode === 'ZH_TW'}
                hovered={active}
              />
            </div>
          </div>
        )}
      </Listbox.Option>
      <Listbox.Option key={`zh-tw-1`} value={{isoCode: 'EN', name: 'English'}}>
        {({active}: {active: boolean}) => (
          <div className={getClassName(active)}>
            <span className="mr-8 font-normal">English</span>
            <div className="text-hk-orange">
              <RadioIcon
                checked={selectedLanguage?.isoCode === 'EN'}
                hovered={active}
              />
            </div>
          </div>
        )}
      </Listbox.Option>
      {/* {languagesAvailable?.map((language, i) => {
        const isSelected =
          language.isoCode === selectedLanguage?.isoCode.replace('-', '_');
        return (
          <Listbox.Option key={`${language.isoCode}-${i}`} value={language}>
            {({active}: {active: boolean}) => (
              <div className={getClassName(active)}>
                <span className="mr-8 font-normal">{language.endonymName}</span>
                <div className="text-hk-orange">
                  <RadioIcon checked={isSelected} hovered={active} />
                </div>
              </div>
            )}
          </Listbox.Option>
        );
      })} */}
    </>
  );
}

export default LanguageSelect;
